var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentMdl2ScaleVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5 6.25H11.1934L27.6973 22.8027L23.3027 27.1973L6.75 10.6934V25H0.5V0H25.5V6.25ZM75.5 0H100.5V25H94.25V10.6934L77.6973 27.1973L73.3027 22.8027L89.8066 6.25H75.5V0ZM23.3027 72.8027L27.6973 77.1973L11.1934 93.75H25.5V100H0.5V75H6.75V89.3066L23.3027 72.8027ZM94.25 89.3066V75H100.5V100H75.5V93.75H89.8066L73.3027 77.1973L77.6973 72.8027L94.25 89.3066ZM31.75 68.75V31.25H69.25V68.75H31.75ZM38 37.5V62.5H63V37.5H38Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2ScaleVolume);
export default __webpack_public_path__ + "static/media/fluent-mdl2_scale-volume.3dade0d13f762e88066e1069706ef7a1.svg";
export { ForwardRef as ReactComponent };